import { configureStore } from "@reduxjs/toolkit";
 
import blogReducer from "../features/blogs/blogSlice";
import contactReducer from '../features/contact/contactSlice';
import courseReducer from '../features/courses/courseSlice';
import eventReducer from '../features/events/eventsSlice';
import bookingReducer from '../features/booking/bookingSlice';
import courseRequestReducer from '../features/courseRequests/courseRequestSlice';


export const store = configureStore({
  reducer: {
  
    blog: blogReducer,
    contact:contactReducer,
    course:courseReducer,
    event:eventReducer,
    booking:bookingReducer,
    courseRequest:courseRequestReducer,
  },
});
